<template>
  <div>
    <LaptopProfile v-if="isLaptop" :isLaptop="isLaptop" />
    <MobProfile v-else :isLaptop="isLaptop" />
  </div>
</template>

<script>
import LaptopProfile from "../AccountSettings/MainProfile.vue";
import MobProfile from "../AccountSettings/MobileProfile.vue";
export default {
  data() {
    return {
      isLaptop: true,
    };
  },
  components: {
    LaptopProfile,
    MobProfile,
  },
  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
  },
  methods: {
    checkScreenSize() {
      this.isLaptop = window.innerWidth >= 1024;
    },
  },
};
</script>
